import React from "react";
import {
  AssistantMessageContent,
  MarkdownData,
  MessageType,
} from "duck/ui/chat/types";

import { MarkdownContent } from "features/ui/MarkdownContent/MarkdownContent";

import { Renderer } from "./types";

const hasMarkdownMessage = (content: AssistantMessageContent): boolean =>
  content.message_type === MessageType.MARKDOWN &&
  "markdown_message" in content &&
  Boolean(content.markdown_message?.trim());

export const MarkdownRenderer: Renderer<AssistantMessageContent> = {
  type: "markdown",

  canRender: (content: AssistantMessageContent): boolean =>
    hasMarkdownMessage(content),

  render: (content: AssistantMessageContent): React.ReactNode => {
    if (!hasMarkdownMessage(content)) return null;

    const { markdown_message } = content as MarkdownData;

    return <MarkdownContent content={markdown_message} />;
  },
};
